export function stickyHeader() {
    const body = document.body;
    let header = document.querySelector(".header");
    let lastScroll = 0;
    function stickyHeaderOnScroll() {
        if (window.scrollY < 1) {
            header.classList.remove("sticky");
        }
        const currentScroll = window.scrollY;
        if (currentScroll === 0) {
            body.classList.remove('up');
            return;
        }
        if (currentScroll > lastScroll && !body.classList.contains('down')) {
            // down
            body.classList.remove('up');
            body.classList.add('down');
        } else if (currentScroll < lastScroll && body.classList.contains('down')) {
            // up
            body.classList.remove('down');
            body.classList.add('up');
        }
        lastScroll = currentScroll;
        if (currentScroll > 0) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }

        if(currentScroll > window.innerHeight / 3 && document.querySelector(".has-fixed-animation")) {
            body.classList.add("scrolled");
        } else{
            body.classList.remove("scrolled");
        }
    }


    window.addEventListener("load", () => {
        stickyHeaderOnScroll();
    });

    window.addEventListener("scroll", stickyHeaderOnScroll);

}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyHeader.js